module.exports = __webpack_public_path__ + "static/img/beijing.7c8571e.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/erpManage/img/beijing.png
// module id = IK6K
// module chunks = 10